import React, { useState, useEffect } from 'react';
import NavbarRolCartera from '../navbarRolCartera';
import BotonWhatsapp from '../../newInterface/botonWhatsapp/botonWhatsapp';
import { message } from 'antd';
import './indemnizacionesRolCartera.css';

const IndemnizacionesRolCartera = () => {
  const [indemTrackingNumberPreenvio, setIndemTrackingNumberPreenvio] = useState('');
  const [indemCarrierPreenvio, setIndemCarrierPreenvio] = useState('interrapidisimo');
  const [indemTrackingNumberServicio, setIndemTrackingNumberServicio] = useState('');
  const [indemCarrierServicio, setIndemCarrierServicio] = useState('interrapidisimo');

  const handleIndemnizacionPreenvio = async () => {
    if (!indemTrackingNumberPreenvio.trim()) {
      message.warning('Por favor ingrese un número de guía');
      return;
    }
    const requestBody = {
      guia: indemTrackingNumberPreenvio,
      transportadora: {
        pais: 'colombia',
        nombre: indemCarrierPreenvio
      }
    };
    try {
      const userId = localStorage.getItem('usuario_id');
      const response = await fetch(`https://integration.99envios.app/api/indemnizacion-preenvio/${userId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });
      const data = await response.json();
      
      if (data.error) {
        message.error(data.error);
      } else {
        message.success(data.success);
        setIndemTrackingNumberPreenvio(''); // Clear input after success
      }
      
    } catch (error) {
      message.error('Error al procesar la solicitud');
    }
  };

  const handleIndemnizacionServicioPreenvio = async () => {
    if (!indemTrackingNumberServicio.trim()) {
      message.warning('Por favor ingrese un número de guía');
      return;
    }
    const requestBody = {
      guia: indemTrackingNumberServicio,
      transportadora: {
        pais: 'colombia',
        nombre: indemCarrierServicio
      }
    };
    try {
      const userId = localStorage.getItem('usuario_id');
      const response = await fetch(`https://integration.99envios.app/api/indemnizacion-servicio-preenvio/${userId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });
      const data = await response.json();

      if (data.error) {
        message.error(data.error);
      } else {
        message.success('Indemnización enviada');
        setIndemTrackingNumberServicio(''); // Clear input after success
      }

    } catch (error) {
      message.error('Error al procesar la solicitud');
    }
  };

  const handleIndemnizacionFromTable = async (guia, transportadora) => {
    const requestBody = {
      guia: guia,
      transportadora: {
        pais: 'colombia',
        nombre: transportadora
      }
    };
    try {
      const userId = localStorage.getItem('usuario_id');
      const response = await fetch(`https://integration.99envios.app/api/indemnizacion-preenvio/${userId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });
      const data = await response.json();
      
      if (data.error) {
        message.error(data.error);
      } else {
        message.success('Indemnización enviada');
        await fetchTableData(); // Refresh tables only on success
      }

    } catch (error) {
      message.error('Error al procesar la solicitud');
    }
  };

  const handleIndemnizacionServicioFromTable = async (guia, transportadora) => {
    const requestBody = {
      guia: guia,
      transportadora: {
        pais: 'colombia',
        nombre: transportadora
      }
    };
    try {
      const userId = localStorage.getItem('usuario_id');
      const response = await fetch(`https://integration.99envios.app/api/indemnizacion-servicio-preenvio/${userId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });
      const data = await response.json();
      
      if (data.error) {
        message.error(data.error);
      } else {
        message.success('Indemnización enviada');
        await fetchTableData(); // Refresh tables only on success
      }

    } catch (error) {
      message.error('Error al procesar la solicitud');
    }
  };

  // New state variables for tables
  const [nullData, setNullData] = useState([]);
  const [nonNullData, setNonNullData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
  
  // Replace single currentPage with separate states for each table
  const [nullCurrentPage, setNullCurrentPage] = useState(1);
  const [nonNullCurrentPage, setNonNullCurrentPage] = useState(1);

  // Replace single search and entries states with separate ones for each table
  const [nullSearch, setNullSearch] = useState('');
  const [nonNullSearch, setNonNullSearch] = useState('');
  const [nullEntriesPerPage, setNullEntriesPerPage] = useState(10);
  const [nonNullEntriesPerPage, setNonNullEntriesPerPage] = useState(10);

  useEffect(() => {
    fetchTableData();
  }, []);

  const fetchTableData = async () => {
    try {
      const [nullResponse, nonNullResponse] = await Promise.all([
        fetch('https://99envios.app/api/online/indemnizaciones/null'),
        fetch('https://99envios.app/api/online/indemnizaciones/no-null')
      ]);

      const nullDataResult = await nullResponse.json();
      const nonNullDataResult = await nonNullResponse.json();

      setNullData(Array.isArray(nullDataResult) ? nullDataResult : [nullDataResult]);
      setNonNullData(nonNullDataResult);
    } catch (error) {
      message.error('Error al cargar los datos de las tablas');
    }
  };

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const sortData = (data) => {
    if (sortConfig.key !== '') {
      return [...data].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return data;
  };

  const filterData = (data, searchTerm) => {
    return data.filter(item =>
      Object.values(item).some(val => 
        val && val.toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  };

  const renderTable = (data, title, searchValue, setSearchValue, entriesValue, setEntriesValue, currentPage, setCurrentPage) => {
    // Get filtered and sorted data
    const filteredAndSortedData = sortData(filterData(data, searchValue));
    
    // Calculate pagination values
    const indexOfLastItem = currentPage * entriesValue;
    const indexOfFirstItem = indexOfLastItem - entriesValue;
    const currentItems = filteredAndSortedData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredAndSortedData.length / entriesValue);
    
    // Function to change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    
    return (
      <div className="indemnizaciones-table-container">
        <h2>{title}</h2>
        <div className="indemnizaciones-table-controls">
          <input
            type="text"
            placeholder="Buscar"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            className="indemnizaciones-search-input"
          />
        </div>
        <div className="indemnizaciones-table-wrapper">
          <table className="indemnizaciones-custom-table">
            <thead>
              <tr>
                <th onClick={() => handleSort('numero_guia')}>Número Guía</th>
                <th onClick={() => handleSort('transportadora')}>Transportadora</th>
                <th onClick={() => handleSort('valor_declarado')}>Valor Declarado</th>
                <th onClick={() => handleSort('valor_servicio')}>Valor Servicio</th>
                <th onClick={() => handleSort('fecha_creacion')}>Fecha Creación</th>
                <th onClick={() => handleSort('nombre_destinatario')}>Destinatario</th>
                <th onClick={() => handleSort('telefono_destinatario')}>Teléfono</th>
                <th onClick={() => handleSort('tipo')}>Estado</th>
                {title === "Indemnizaciones Pendientes" && (
                  <th>Tipo Indemnización</th>
                )}
                {title === "Indemnizaciones Procesadas" && (
                  <th>Tipo Indemnización</th>
                )}
              </tr>
            </thead>
            <tbody>
              {currentItems.map((item) => (
                <tr key={item.id}>
                  <td>{item.numero_guia}</td>
                  <td>{item.transportadora}</td>
                  <td>{item.valor_declarado}</td>
                  <td>{item.valor_servicio}</td>
                  <td>{new Date(item.fecha_creacion).toLocaleDateString()}</td>
                  <td>{item.nombre_destinatario}</td>
                  <td>{item.telefono_destinatario}</td>
                  <td>{item.tipo === 1 ? 'Procesada' : 'No procesada'}</td>
                  {title === "Indemnizaciones Pendientes" && (
                    <td>
                      <div className="action-buttons">
                        <button 
                          onClick={() => handleIndemnizacionFromTable(item.numero_guia, item.transportadora)}
                          className="search-button"
                        >
                          Valor Comercial
                        </button>
                        <button 
                          onClick={() => handleIndemnizacionServicioFromTable(item.numero_guia, item.transportadora)}
                          className="search-button"
                        >
                          Valor Flete
                        </button>
                      </div>
                    </td>
                  )}
                  {title === "Indemnizaciones Procesadas" && (
                    <td>{item.tipo === 1 ? 'Servicio' : item.tipo === 2 ? 'Valor Servicio' : 'No especificado'}</td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
        {/* Advanced Pagination - similar to sucursalPedidos */}
        {filteredAndSortedData.length > 0 && (
          <div className="custom-pagination-indemnizaciones-rol-cartera">
            <div className="pagination-info-indemnizaciones-rol-cartera">
              Mostrando {indexOfFirstItem + 1} a {Math.min(indexOfLastItem, filteredAndSortedData.length)} de {filteredAndSortedData.length} registros
            </div>
            <div className="pagination-controls-indemnizaciones-rol-cartera">
              {/* Show "1" button only if not already visible in central buttons */}
              {currentPage > 2 && (
                <button 
                  onClick={() => paginate(1)} 
                  className="pagination-button-indemnizaciones-rol-cartera"
                >
                  1
                </button>
              )}
              
              {/* Show previous button only if not on first page */}
              {currentPage > 1 && (
                <button 
                  onClick={() => paginate(currentPage - 1)} 
                  className="pagination-button-indemnizaciones-rol-cartera"
                >
                  &lt;
                </button>
              )}
              
              {/* Page numbers */}
              <div className="pagination-pages-indemnizaciones-rol-cartera">
                {(() => {
                  // Show only current page and one page before/after
                  const pagesToShow = [];
                  
                  // Add previous page if it exists
                  if (currentPage > 1) {
                    pagesToShow.push(currentPage - 1);
                  }
                  
                  // Add current page
                  pagesToShow.push(currentPage);
                  
                  // Add next page if it exists
                  if (currentPage < totalPages) {
                    pagesToShow.push(currentPage + 1);
                  }
                  
                  return pagesToShow.map(pageNum => (
                    <button 
                      key={pageNum}
                      onClick={() => paginate(pageNum)}
                      className={`pagination-button-indemnizaciones-rol-cartera ${currentPage === pageNum ? 'active' : ''}`}
                    >
                      {pageNum}
                    </button>
                  ));
                })()}
              </div>
              
              {/* Show next button only if not on last page */}
              {currentPage < totalPages && (
                <button 
                  onClick={() => paginate(currentPage + 1)} 
                  className="pagination-button-indemnizaciones-rol-cartera"
                >
                  &gt;
                </button>
              )}
              
              {/* Show last page button only if not already visible */}
              {currentPage < totalPages - 1 && (
                <button 
                  onClick={() => paginate(totalPages)} 
                  className="pagination-button-indemnizaciones-rol-cartera"
                >
                  {totalPages}
                </button>
              )}
            </div>
            <div className="items-per-page-indemnizaciones-rol-cartera">
              <span>Registros por página: </span>
              <select 
                value={entriesValue} 
                onChange={(e) => {
                  setEntriesValue(Number(e.target.value));
                  setCurrentPage(1);
                }}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <NavbarRolCartera title="Indemnizaciones" />
      <div className="indemnizaciones-container">
        <div className="indemnizacion-box">
          <h2>INDEMNIZACIÓN VALOR COMERCIAL</h2>
          <div className="search-bar">
            <input
              type="text"
              value={indemTrackingNumberPreenvio}
              onChange={(e) => setIndemTrackingNumberPreenvio(e.target.value)}
              placeholder="Número de guía"
              className="search-input"
            />
            <select
              value={indemCarrierPreenvio}
              onChange={(e) => setIndemCarrierPreenvio(e.target.value)}
              className="carrier-select"
            >
              <option value="interrapidisimo">Interrapidisimo</option>
              <option value="servientrega">Servientrega</option>
              <option value="coordinadora">Coordinadora</option>
              <option value="tcc">TCC</option>
            </select>
            <button 
              onClick={handleIndemnizacionPreenvio} 
              className="search-button"
              disabled={!indemTrackingNumberPreenvio.trim()}
            >
              Enviar
            </button>
          </div>
        </div>

        <div className="indemnizacion-box">
          <h2>INDEMNIZACIÓN VALOR SERVICIO FLETE</h2>
          <div className="search-bar">
            <input
              type="text"
              value={indemTrackingNumberServicio}
              onChange={(e) => setIndemTrackingNumberServicio(e.target.value)}
              placeholder="Número de guía"
              className="search-input"
            />
            <select
              value={indemCarrierServicio}
              onChange={(e) => setIndemCarrierServicio(e.target.value)}
              className="carrier-select"
            >
              <option value="interrapidisimo">Interrapidisimo</option>
              <option value="servientrega">Servientrega</option>
              <option value="coordinadora">Coordinadora</option>
              <option value="tcc">TCC</option>
            </select>
            <button 
              onClick={handleIndemnizacionServicioPreenvio} 
              className="search-button"
              disabled={!indemTrackingNumberServicio.trim()}
            >
              Enviar
            </button>
          </div>
        </div>
      </div>
      
      {renderTable(
        nullData, 
        "Indemnizaciones Pendientes", 
        nullSearch, 
        setNullSearch, 
        nullEntriesPerPage, 
        setNullEntriesPerPage,
        nullCurrentPage,
        setNullCurrentPage
      )}
      {renderTable(
        nonNullData, 
        "Indemnizaciones Procesadas", 
        nonNullSearch, 
        setNonNullSearch,
        nonNullEntriesPerPage,
        setNonNullEntriesPerPage,
        nonNullCurrentPage,
        setNonNullCurrentPage
      )}
      
      <BotonWhatsapp />
    </>
  );
};

export default IndemnizacionesRolCartera;
